import { getDateRangeArray } from "@/lib/dayjs/get-date-range-array";
import { getMonthRangeByDate } from "@/lib/dayjs/get-month-range-by-date";

/**
 * 表示月の月初〜月末（在庫ページと同じ期間）を startDt / endDt で返す。
 * GraphQL rateMatrix の取得範囲とテーブル列の日付範囲に使う。
 */
export const getMonthDateRange = (yearMonth: string): { startDt: string; endDt: string } => {
	const { firstDay, lastDay } = getMonthRangeByDate(`${yearMonth}-01`);
	return { startDt: firstDay, endDt: lastDay };
};

/** 表示月に属する日付一覧（YYYY-MM-DD）。隣接月は含めない */
export const getMonthDates = (yearMonth: string): string[] => {
	const { startDt, endDt } = getMonthDateRange(yearMonth);
	return getDateRangeArray({ startDate: startDt, endDate: endDt });
};
